import React from 'react';
import { observer } from 'mobx-react';

import { Checkbox, Switch, Button, Radio, Input } from 'antd';
import { PinGen, PinComp, PinFoto } from "./CustomIcons";

@observer
class ScreenshotPanel extends React.Component {
	render() {
		return (
		<div className="screenshot-side">

			<div>
				<div className="generali-options">
					<div className="header">Marker Generali</div>
					<Checkbox>Tutti i marker dello stesso colore</Checkbox><br/>
					<Checkbox><PinGen/>Marker neutro</Checkbox><br/>
					<Checkbox><PinFoto/>Marker per foto</Checkbox>
				</div>

				<div className="competitor-options">
					
					<div className="header">Marker Competitor <Switch size="small" className="competitor-onoff" onClick={ (checked, e) => { e.stopPropagation() } } checkedChildren="on" unCheckedChildren="off" defaultChecked/></div>
					<p>clicca su un punto qualsiasi della mappa per aggiungere un marker competitor</p>
					<Radio.Group>
					<Radio value={1}><PinComp/>Marker standard</Radio>
					<Radio value={2}><PinFoto/>Marker per foto</Radio>
				    </Radio.Group>
					
					<div className="search-screenshot">
						<Input.Search
							placeholder="Cerca un indirizzo"
							style={{ width: '100%' }}
							/>
					</div>
				</div>
			</div>

		</div>
		);
	}
}

export { ScreenshotPanel };
